module.exports = __webpack_public_path__ + "img/img2.5e99459.png";